import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

function CoreEditIcon(props: SvgIconProps) {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.933 0.401285C13.51 -0.0217826 12.824 -0.0217826 12.401 0.401285L0.484293 12.318C0.281129 12.5211 0.166992 12.7967 0.166992 13.084V17.4173C0.166992 18.0156 0.652017 18.5007 1.25033 18.5007H5.58366C5.87098 18.5007 6.14653 18.3865 6.34969 18.1833L18.2664 6.26668C18.6894 5.84362 18.6894 5.15769 18.2664 4.73462L13.933 0.401285ZM2.33366 16.334V13.5327L13.167 2.69938L15.9683 5.50065L5.13493 16.334H2.33366ZM1.25033 21.7507C0.652017 21.7507 0.166992 22.2357 0.166992 22.834C0.166992 23.4323 0.652017 23.9173 1.25033 23.9173H20.7503C21.3486 23.9173 21.8337 23.4323 21.8337 22.834C21.8337 22.2357 21.3486 21.7507 20.7503 21.7507H1.25033Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoCoreEditIcon = React.memo(CoreEditIcon);
export default MemoCoreEditIcon;
